
<template>
  <Modal
    :value="visible"
    class-name="editTaxModal"
    :title="$t('setting_new_1344')"
    :footer-hide="true"
    :width="700"
    @on-cancel="toggle"
  >
      <TablePaginate
        :columns="columns"
        :data="dataList"
        :loading="loading"
        :meta="meta"
        :noPagination="true"
        :onSelectionChange="onSelectionChange"
      ></TablePaginate>

    <Button
      type="primary"
      size="large"
      style="width: 150px;margin-top: 10px;"
      @click="onSubmit"
      >{{ $t("pages_combo_index_284") }}</Button
    >
  </Modal>
</template>

<script>
import i18n from "../../../locales/index";

import { mapActions, mapState, mapGetters } from "vuex";
import _ from "lodash";
import TablePaginate from "@/components/TablePaginate";
import { formatDateTime } from "@/libs/table-render";

export default {
  name: "EditMaterialModal",
  props: ["visible", "selected"],
  components: { TablePaginate },
  data() {
    return {
      selectedData: [],
      dataList: [],
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: i18n.t("pages_banners_index_181"),
          width: 200,
          key: "name",
        },
        {
          title: i18n.t("setting_new_1345"),
          key: "scope_text",
          width: 200,
          align: "center",
        },
        {
          title: i18n.t("setting_new_1344"),
          key: "rate",
          width: 200,
          align: "center",
        },
      ],
    };
  },
  computed: {
    ...mapState("tax", ["taxes"]),
    ...mapGetters("tax", ["meta", "loading"]),
  },
  watch: {
    selected: {
      immediate: true,
      handler(list = []) {
        console.log(list)
        this.selectedData = list
        this.initChecked(this.dataList);
      },
    },
    taxes: {
      immediate: true,
      handler(list = []) {
        this.initChecked(list);
      },
    },
  },
  methods: {
    ...mapActions("material", {
      fetchData: "index",
    }),
    initChecked(list) {
      const ids = _.map(this.selectedData, "tax_id");

      this.dataList = list.map((item) => {
        if (ids.includes(item.id)) {
          item._checked = true;
        } else {
          item._checked = false;
        }
        return item;
      });
    },
    onSelectionChange(selection) {
      this.selectedData = [...selection];
    },
    onSubmit() {
      const ids = _.map(this.dataList, "id");
      const selectedData = [];

      this.selectedData.map((item) => {
        if (ids.includes(item.id)) {
          selectedData.push(item);
        }
      });
      const submitData = selectedData

      this.$emit("submit", submitData);
      this.toggle();
    },
    toggle() {
      this.$emit("toggle");
    },
  },
  mounted() {
    this.fetchData({ page: 1, per: 65535 });
  },
};
</script>

<style lang="scss" scoped>
.editMaterialModal {
  button {
    display: block;
    margin: 30px auto 0;
  }
}
</style>
